import RenderCell from './RenderCell';

import styles from './RenderCell.module.css';

interface LocationCellProps {
	name?: string;
	city?: string;
	state?: string;
	editable?: boolean;
}

export default function LocationSlot(props: LocationCellProps) {
	const cityStateDisplay = `${props.city ? props.city : ''}${props.city && props.state ? ', ' : ''}${props.state ? props.state : ''}`;

	const CityStateContents = () => {
		if (props.city && props.state) {
			return (
				<>
					<span className={styles['city']}>{props.city}</span>, {props.state}
				</>
			);
		}

		if (props.city) {
			return <>{props.city}</>;
		}

		if (props.state) {
			return <>{props.state}</>;
		}

		return undefined;
	};

	return (
		<RenderCell
			editable={props.editable}
			primarySlot={
				props.name && (
					<span
						className={styles.bold}
						title={props.name}
					>
						{props.name}
					</span>
				)
			}
			secondarySlot={
				(props.city || props.state) && (
					<span
						className={`${styles['secondary-text']} ${styles['city-state']}`}
						title={cityStateDisplay}
					>
						<CityStateContents />
					</span>
				)
			}
		/>
	);
}
